var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"preview-modal__loading"},[_c('FileIconComponent',{attrs:{"name":"loading"}})],1):_c('ProductComponent',{attrs:{"data":_vm.product,"is-modal":""},on:{"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }